import { lazy } from 'react';
// ----------------------------------------------------------------------

const CustomerByTypePage = lazy(() => import('../pages/CustomerByType.page'));


// ----------------------------------------------------------------------

const CustomerByTypeRoutes = [
    {
        path: 'sales',
        children: [
            { element: <CustomerByTypePage />, layout: 'default', isAuthReq: true, index: true },
            // {
            //     path: 'add-customer',
            //     element: <AddCustomerPage />,
            //     layout: 'default',
            //     isAuthReq: true,
            // },



        ],
    },

];

export { CustomerByTypeRoutes };
